module.exports = __webpack_public_path__ + "img/MapPicsEqualFooting.f5facd57.webp";